import { Controller } from "@hotwired/stimulus"

// Saves one cell on the class-picture print tracking screen (a note, or the
// "No composite" checkbox), or the composites page's "Staff centered on top
// row" checkbox, without submitting a form. Mirrors
// auto_save_flag_controller: PATCH on change, revert on failure.
//
// One controller for both fields rather than two near-identical ones -- the field
// name travels in a value, and the endpoint decides what it means.
export default class extends Controller {
  static values = { url: String, field: String }

  save(event) {
    const input = event.target
    const checkbox = input.type === "checkbox"
    const previous = checkbox
      ? !input.checked
      : (typeof input.dataset.previousValue === "string" ? input.dataset.previousValue : input.defaultValue)
    input.disabled = true

    const body = {}
    body[this.fieldValue] = checkbox ? input.checked : input.value

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify(body)
    })
      .then((response) => {
        // A refusal can carry a sentence (HC Proofs: why no project was made).
        if (!response.ok) {
          return response.json().catch(() => ({})).then((data) => { throw new Error(data.message || response.status) })
        }
        return response.json()
      })
      .then((data) => {
        input.disabled = false
        if (checkbox) {
          this.show(input, data[this.fieldValue])
          this.showProject(input, data)
        } else {
          input.value = data[this.fieldValue]
          input.dataset.previousValue = input.value
        }
        input.style.backgroundColor = "#dff0d8"
        setTimeout(() => { input.style.backgroundColor = "" }, 600)
      })
      .catch((error) => {
        // Put the old value back rather than leaving the screen claiming a save
        // that did not happen -- this number drives what gets reprinted.
        input.disabled = false
        if (checkbox) this.show(input, previous)
        else input.value = previous
        input.style.backgroundColor = "#f2dede"
        const box = this.projectBox(input)
        if (box && error && isNaN(Number(error.message))) {
          box.textContent = ""
          const note = document.createElement("div")
          note.style.color = "#a94442"
          note.textContent = error.message
          box.appendChild(note)
        }
      })
  }

  // The HC Proofs cell's project line: a link to the project the tick opened
  // (or reopened, or cancelled) and what happened to it.
  showProject(input, data) {
    const box = this.projectBox(input)
    if (!box || !data.project_url) return

    box.textContent = ""
    const link = document.createElement("a")
    link.href = data.project_url
    link.target = "_blank"
    link.rel = "noopener"
    link.textContent = `Project ${data.project_id}`
    const note = document.createElement("div")
    note.style.color = "#777"
    note.textContent = data.project_message || ""
    box.append(link, note)
  }

  projectBox(input) {
    return input.closest("td")?.querySelector("[data-hc-project]")
  }

  // A checkbox may carry data-row-class: the class its table row wears while
  // checked (the greyed-out "No composite" school).
  show(input, checked) {
    input.checked = checked
    const rowClass = input.dataset.rowClass
    if (rowClass) input.closest("tr")?.classList.toggle(rowClass, checked)
  }
}
